import type { Meter } from '@vy/types';
import { type Optional, isNotEmptyArray } from '@vy/utils';
import { useMemo } from 'react';
import { filterMetersByEventNames } from '../data-metering-types/data-metering-select-filters';

export function useEventNameMeters(selectedEventNames: Optional<string[]>, meters: Meter[]) {
  return useMemo(
    () =>
      isNotEmptyArray(selectedEventNames) ? filterMetersByEventNames(meters, selectedEventNames) : meters,
    [selectedEventNames, meters],
  );
}
